import { AlertTriangle } from "lucide-react";

interface FieldErrorProps {
  message: string;
}

export function FieldError({ message }: FieldErrorProps) {
  return (
    <span className="flex items-center gap-1 text-[12px] font-medium text-[#E02800]">
      <AlertTriangle className="size-3 shrink-0" strokeWidth={2} />
      {message}
    </span>
  );
}
